import type { AccountMenuLink } from '../model/types';

export const ACCOUNT_MENU_LINKS: AccountMenuLink[] = [
  { key: 'orders', label: 'Заказы', path: '#/orders', external: true },
  { key: 'tourhunter', label: 'Турхантер', path: '#/tourhunter', external: true },
  { key: 'settings', label: 'Настройки', path: '#/settings', external: true },
];

export const LOGOUT_LABEL = 'Выйти';
